require.register("app/supplier/stat/NetSaleView", function(exports, require, module){
  $0
  
});

